// Angular imports
import { Component, AfterViewInit, Input, ViewChild } from '@angular/core';

// 3rd party imports
import * as moment from 'moment-timezone';

// 3rd party imports
import { DxChartComponent, DxPieChartComponent } from 'devextreme-angular';

// Component imports
import { MPBasePieChartComponent } from '../../../_base/mp-base-pie-chart.component';

// Service imports
import { ScreenService } from './../../../_services/shared-services/screen.service';
import { HelperService } from './../../../_services/shared-services/helper.service';
import { ContextManagerService } from '../../../_services/data-services/context-manager.service';

// Model imports
import { PlattedLotResultDto } from '../../_models/platted-lot-result-dto';
import { UserService } from '../../../_services/data-services/user.service';

@Component({
    selector: 'app-platted-lot-pie-chart',
    templateUrl: './platted-lot-pie-chart.component.html',
    styleUrls: ['./platted-lot-pie-chart.component.scss']
})
export class PlattedLotPieChartComponent extends MPBasePieChartComponent implements AfterViewInit {
    @ViewChild(DxPieChartComponent, { static: false }) pieChart: DxChartComponent;

    @Input() palette: string;
    @Input() paletteMode: string;
    @Input() chartData: PlattedLotResultDto[];

    plattedLotChartData: PlattedLotResultDto[];
    plattedLotChartPalette: string | string[];
    plattedLotChartTitle = `As of ${moment(new Date()).format('MMM DD, YYYY')}`;

    constructor(
        protected readonly screenService: ScreenService,
        protected contextManagerService: ContextManagerService,
        protected helperService: HelperService,
        protected userService: UserService
    ) {
        super(screenService, contextManagerService, helperService, userService);
    }

    ngAfterViewInit(): void {
        setTimeout(() => this.bindChartData(this.chartData), 100);
    }

    customizeText = (pointInfo) => {
        if (pointInfo.pointName === 'No Data') {
            return pointInfo.pointName;
        } else {
            const point = this.plattedLotChartData[pointInfo.pointIndex];
            const pointName = this.getPointName(pointInfo);
            return `${pointName}\n${point.lotCount}, ${point.percentage}%`;
        }
    };

    exportFileName = (): string => {
        return this.getExportFileName(this.plattedLotChartTitle);
    };

    private bindChartData(data?: PlattedLotResultDto[]): void {
        if (!data || data.length === 0) {
            const empty = new PlattedLotResultDto();
            empty.title = 'No Data';
            empty.lotCount = 0;
            empty.percentage = 0;
            data = [empty];
            this.plattedLotChartPalette = ['#ccc'];
        }
        this.legendCount = data.length;
        this.plattedLotChartData = data;

        setTimeout(() => {
            this.chart = this.pieChart;
            this.setChartSize();
        }, 250);
    }
}
